module.exports = __webpack_public_path__ + "img/front2.f208f173.png";